var map = {
	"./black/shanchu2.png": "G+bN",
	"./blue/shanchu2.png": "OIIB",
	"./white/shanchu2.png": "X2Az"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aDr8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/shanchu2\.png$
// module id = aDr8
// module chunks = 24